import axios from 'axios';
import { API, TYPE_PRODUCT } from '../../constants';

const createAction = name => ({
    CATEGORY_CHANGE: `${name}_CATEGORY_CHANGE`,
    CURRENT_PAGE_CHANGE: `${name}_CURRENT_PAGE_CHANGE`,
    CATEGORY_ITEM_PENDING: `${name}_CATEGORY_ITEM_PENDING`,
    CATEGORY_ITEM_SUCCESS: `${name}_CATEGORY_ITEM_SUCCESS`,
    CATEGORY_ITEM_FAILED: `${name}_CATEGORY_ITEM_FAILED`
});

export const CATEGORY = createAction('CATEGORY');

export const CategoryNameChange = value => dispatch => {
    dispatch({
        type: CATEGORY.CATEGORY_CHANGE,
        payload: value
    });
};

export const CurrentPageChange = page => dispatch => {
    dispatch({
        type: CATEGORY.CURRENT_PAGE_CHANGE,
        payload: page
    });
};

let categoryName = "";

export const ItemByCategoryName = () => async (dispatch, getState) => {
    dispatch({ type: CATEGORY.CATEGORY_ITEM_PENDING });
    try {
        const { categories, language } = getState();
        const url = categories.categoryName === TYPE_PRODUCT.VOUCHER.TH ? 
            API.GET_VOUCHER_ITEM:
            `${API.ITEM_BY_CATEGORY}?name=${categories.categoryName}`;
        categoryName = categories.categoryName;
        const response = await axios
            .get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': language.currentLanguage
                }
            })
            .then(res => res.data)
            .catch(error => Promise.reject(error));

        if (categoryName == categories.categoryName) {
            dispatch({
                type: CATEGORY.CATEGORY_ITEM_SUCCESS,
                payload: response
            });
        }
    } catch (error) {
        dispatch({
            type: CATEGORY.CATEGORY_ITEM_FAILED,
            error
        });
    }
};
